export default __webpack_public_path__ + "static/media/mobile-marketing-bro.1b9952e0.svg";